var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigestive3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.675,
    height: 47,
    viewBox: "0 0 27.675 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7635",
    "data-name": "Group 7635",
    transform: "translate(171.818 -651.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4312",
    "data-name": "Path 4312",
    d: "M-167.526,792.487c-.374-.117-.756-.215-1.122-.354a4.988,4.988,0,0,1-3.155-5,.728.728,0,0,1,.049-.148h27.546a4.864,4.864,0,0,1-2.685,4.957,13.63,13.63,0,0,1-1.538.543Z",
    transform: "translate(0 -93.765)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4313",
    "data-name": "Path 4313",
    d: "M-144.069,714.929v19.285h-27.607V714.929Zm-13.533,3.278-5.805,7.74h5.527l-2.485,3.318,2.211,1.658,5.819-7.761h-5.527l2.468-3.3Z",
    transform: "translate(-0.098 -43.815)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4314",
    "data-name": "Path 4314",
    d: "M-149.645,678.816v2.741A5.075,5.075,0,0,1-145,683.7a5.077,5.077,0,0,1,.874,3.368h-27.619a4.98,4.98,0,0,1,1.442-4.055,5.136,5.136,0,0,1,4.068-1.454v-2.746Z",
    transform: "translate(-0.037 -18.782)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4315",
    "data-name": "Path 4315",
    d: "M-140.682,657.221h-22.051c-.484-3.1,1.155-5.072,3.514-5.453a4.872,4.872,0,0,1,.777-.044q6.7,0,13.4,0a4.143,4.143,0,0,1,4.362,4.3C-140.677,656.412-140.682,656.805-140.682,657.221Z",
    transform: "translate(-6.239)",
    fill: "#aceb1e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigestive3);
export default __webpack_public_path__ + "static/media/digestive3.b904bdc7e381886f29c5cb9ece960f73.svg";
export { ForwardRef as ReactComponent };